const Response = ({ response }) => (
  <div className="blockquote review-response mx-2 my-0 px-3 py-1">
    <div className="fs-5">Campground Response</div>

    <p className="text-default">{response.content}</p>
  </div>
)

export default Response
